import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Disable right-click context menu to protect images
document.addEventListener('contextmenu', (e) => {
  e.preventDefault();
  return false;
});

// Disable drag on images
document.addEventListener('dragstart', (e) => {
  if (e.target.tagName === 'IMG') {
    e.preventDefault();
    return false;
  }
});

// Disable keyboard shortcuts for saving
document.addEventListener('keydown', (e) => {
  // Disable Ctrl+S, Ctrl+U, Ctrl+Shift+I
  if ((e.ctrlKey || e.metaKey) && (e.key === 's' || e.key === 'u' || (e.shiftKey && e.key === 'I'))) {
    e.preventDefault();
    return false;
  }
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
